import React, { useEffect } from "react";

import AuditLogPage from "../../components/APanel/AuditLog/AuditLogPage";

// Admin → Jurnal acțiuni: cine, ce, cui și cu ce rezultat, cu filtrele în rândul de sus.
export default function APAuditLog() {
   useEffect(() => {
      document.title = "Instruire Auto | Jurnal acțiuni";
   }, []);

   return (
      <main className="main">
         <section className="page-wrapper">
            <AuditLogPage />
         </section>
      </main>
   );
}
